// extracted by mini-css-extract-plugin
module.exports = {"root":"OutsideClickHandler_root__2BPyT"};